import { render, staticRenderFns } from "./DestinationPage.vue?vue&type=template&id=3fcd0416"
import script from "./DestinationPage.vue?vue&type=script&lang=ts"
export * from "./DestinationPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports